import { useContext } from 'react'
import { AudienceContext } from 'src/context/AudienceContext'
import { AuthContext } from 'src/context/AuthContext'
import { PromotionalCampaignContext } from 'src/context/PromotionalCampaignContext'
import { CustomReportContext } from 'src/context/CustomReportsContext'
import { DashboardContext } from 'src/context/DashBoardContext'
import { SegmentContext } from 'src/context/SegmentContext'
import { TemplateContext } from 'src/context/TemplateContext'
import { JourneyContext } from 'src/context/JourneyContext'
import { TransactionalCampaignContext } from 'src/context/TransactionalCampaignContext'
import { CampaignContext } from 'src/context/CampaignContext'
import { CampaignAudienceDashboardContext } from 'src/context/CampaignAudienceDashboadContext'
import { MediaLibraryContext } from 'src/context/MediaLibraryContext'

export const useAuth = () => useContext(AuthContext)
export const useSegmentAuth = () => useContext(SegmentContext)
export const useCampaignAuth = () => useContext(CampaignContext)
export const usePromotionalCampaignAuth = () => useContext(PromotionalCampaignContext)
export const useTXCampaignAuth = () => useContext(TransactionalCampaignContext)
export const useAudienceAuth = () => useContext(AudienceContext)
export const useCustomReports = () => useContext(CustomReportContext)
export const useDashboardAuth = () => useContext(DashboardContext)
export const useTemplateAuth = () => useContext(TemplateContext)
export const useJourneyAuth = () => useContext(JourneyContext)
export const useCampaignAudienceDashboardAuth = () => useContext(CampaignAudienceDashboardContext)
export const useMediaLibraryAuth = () => useContext(MediaLibraryContext)
